"use strict";

/**
 *	Vars
 */

	let smoothScroll = null;


/**
 *	Add class
 */

	export function addClass( node, className ) {
		if ( node.length ) {
			Array.prototype.forEach.call( node, function( self ) {
				_addClass( self, className );
			});
		} else {
			_addClass( node, className );
		}
	}


/**
 *	Remove class
 */

	export function removeClass( node, classes ) {
		var array = classes.split( " " );

		if ( node.classList ) {
			for ( var i = 0; i < array.length; i++ ) {
				node.classList.remove( array[i] );
			}
		} else {
			node.className = el.className.replace( new RegExp('(^|\\b)' + array.join('|') + '(\\b|$)', 'gi'), ' ' );
		}
	}


/**
 *	Has class
 */

	export function hasClass( node, className ) {
		if ( node.classList ) {
			return node.classList.contains( className );
		} else {
			return new RegExp('(^| )' + className + '( |$)', 'gi').test( node.className );
		}
	}


/**
 *	Toggle class
 */

	export function toggleClass( node, className ) {
		if ( node.classList ) {
			node.classList.toggle( className );
		} else {
			var classes = node.className.split( ' ' ),
				existingIndex = classes.indexOf( className );

			if ( existingIndex >= 0 ) {
				classes.splice( existingIndex, 1 );
			} else {
				classes.push( className );
				node.className = classes.join( ' ' );
			}
		}
	}


/**
 *	On
 *
 *	Mouse wheel listener:
 *	https: //stackoverflow.com/questions/14926366/mousewheel-event-in-modern-browsers
 */

	export function on( node, event, listener, data ) {
		node.addEventListener( event, listener );

		if ( event === "mousewheel" ) {
			node.addEventListener( "DOMMouseScroll", listener );
		}
	}


/**
 *	Off
 */

	export function off( node, event, listener ) {
		node.removeEventListener( event, listener );

		if ( event === "mousewheel" ) {
			node.removeEventListener( "DOMMouseScroll", listener );
		}
	}


/**
 *	Trigger
 */

	export function trigger( node, eventName, data ) {
		var event;

		if ( window.CustomEvent ) {
			event = new CustomEvent( eventName, {
				cancelable: true,
				detail: data
			});
		} else {
			event = document.createEvent( "CustomEvent" );
			event.initCustomEvent( eventName, true, true, data );
		}

		node.dispatchEvent( event );
	}


/**
 *	Size
 */

	export function size( node ) {
		return document.querySelector( node ).getBoundingClientRect();
	}


/**
 *	To
 */

	export function to( wrap, node, duration, callBack ) {
		var startPosition = ( wrap != "" ) ? wrap.scrollTop : window.pageYOffset,
			endPosition = ( node === "top" ) ? ( window.pageYOffset * -1 ) : ( (typeof node != "number") ? size(node).top : node ),
			startTime = null,
			animation = null;

		function animate( currentTime ) {
			if ( startTime === null ) {
				startTime = currentTime;
			}

			var timeElapsed = currentTime - startTime,
				run = ease( timeElapsed, startPosition, endPosition, duration ); //noEase( timeElapsed, startPosition, endPosition, duration ); 

			if ( wrap != "" ) {
				wrap.scrollTo( 0, run );
			} else {
				window.scrollTo( 0, run );
			}
			

			if ( timeElapsed < duration ) {
				smoothScroll = requestAnimationFrame( animate );
			} else {
				smoothScroll = null;
				
				//console.log( "The end" );

				if ( typeof callBack === "function" ) {
					callBack();	
				}
			}
		}
		
		function noEase (t, b, c, d) {
			return c * t / d + b;
		}

		function ease( t, b, c, d ) {
			t /= d / 2;
			if ( t < 1 ) return c / 2 * t * t * t + b;
			t -= 2;
			return c / 2 * ( t * t * t + 2 ) + b;
		};

		smoothScroll = requestAnimationFrame( animate );
	}


/**
 *	Stop smooth scroll
 *
 *	Discussion:
 *	https: //stackoverflow.com/questions/10735922/how-to-stop-a-requestanimationframe-recursion-loop
 */

	export function stopSmoothScroll() {
		cancelAnimationFrame( smoothScroll );
		smoothScroll = null;
	}


/**
 *	_ Add class
 */

	function _addClass( node, className ) {
		var values = className.split( " " );

		if ( node.classList ) {
			for ( var i = 0; i < values.length; i++ ) {
				node.classList.add( values[i] );
			}
		} else {
			var prefix = ( node.className == "" ) ? "" : " ";

			node.className += prefix + className;
		}
	}